import { datadogLogs } from '@datadog/browser-logs';

import { identifyUser } from './identifyUser';
import { initMonitoring } from './initMonitoring';
import { isMonitoringEnabled } from './isMonitoringEnabled';
export { identifyUser, initMonitoring, isMonitoringEnabled };
export const logger = datadogLogs.logger;
